import React, { useState, useEffect } from 'react';
import { getHomePhotos } from '@/services/contentApi';

const SKELETON_COUNT = 6;

const AnnathanamImageStrip: React.FC = () => {
  const [images, setImages] = useState<string[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      getHomePhotos().then((urls) => {
        if (cancelled) return;
        if (urls.length > 0) setImages(urls);
        setLoaded(true);
      });
    };
    load();
    const interval = setInterval(load, 120000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  const trackImages = images.length ? Array(2).fill(images).flat() : [];
  const showSkeleton = !loaded;

  return (
    <section
      aria-label="Main page photo strip"
      className="bg-white py-4 md:py-6 overflow-hidden"
    >
      <div className="container-custom-full">
        <div
          className="carousel-wrapper"
          style={{
            overflow: 'hidden',
            width: '100%',
            maxWidth: '1100px',
            position: 'relative',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          {showSkeleton ? (
            <div
              style={{
                display: 'flex',
                gap: '24px',
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}
              aria-hidden="true"
            >
              {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
                <div
                  key={index}
                  className="animate-pulse bg-[#E8EDF5]"
                  style={{
                    width: '260px',
                    height: '180px',
                    borderRadius: '16px',
                  }}
                />
              ))}
            </div>
          ) : trackImages.length > 0 ? (
            <div
            className="card-track home-photo-track"
            style={{
              display: 'flex',
              gap: '24px',
              width: 'max-content',
              animation: 'stream-loop-rtl 50s linear infinite',
            }}
            >
              {trackImages.map((src, index) => (
                <div
                  key={index}
                  className="stream-card"
                  style={{
                    width: '260px',
                    flexShrink: 0,
                    borderRadius: '16px',
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                    overflow: 'hidden',
                  }}
                >
                  <img
                    src={src}
                    alt="Diya Charity"
                    loading="lazy"
                    decoding="async"
                    style={{
                      width: '100%',
                      height: '180px',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      target.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default AnnathanamImageStrip;
